import { fmtAUD } from "@/lib/finance";

function Bar({ share, color }) {
  return (
    <div className="h-1 w-full rounded-full bg-neutral-800">
      <div className="h-1 rounded-full" style={{ width: `${Math.min(share, 100)}%`, background: color }} />
    </div>
  );
}

export function CategoryTable({ title, rows, color, testId }) {
  const total = rows.reduce((s, r) => s + r.amount, 0);
  return (
    <div className="rounded-sm border border-border bg-card" data-testid={testId}>
      <div className="flex items-center justify-between border-b border-border px-4 py-3">
        <h3 className="text-sm font-medium tracking-tight">{title}</h3>
        <span className="tabular text-sm font-semibold" style={{ color }}>{fmtAUD(total)}</span>
      </div>
      <div className="divide-y divide-border">
        {rows.length === 0 && (
          <p className="px-4 py-4 text-xs text-muted-foreground">No transactions.</p>
        )}
        {rows.map((r) => (
          <div key={r.category} className="px-4 py-2.5" data-testid={`cat-row-${r.category}`}>
            <div className="flex items-center justify-between text-xs">
              <span className="text-neutral-200">{r.category}</span>
              <div className="flex items-center gap-3 tabular">
                <span className="text-muted-foreground">{r.count} txn</span>
                <span className="w-10 text-right text-muted-foreground">{r.share.toFixed(0)}%</span>
                <span className="w-24 text-right font-medium" style={{ color }}>{fmtAUD(r.amount)}</span>
              </div>
            </div>
            <div className="mt-2">
              <Bar share={r.share} color={color} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function SourceSummary({ rows }) {
  return (
    <div className="rounded-sm border border-border bg-card" data-testid="source-summary">
      <div className="border-b border-border px-4 py-3">
        <h3 className="text-sm font-medium tracking-tight">By card & account</h3>
      </div>
      <table className="w-full text-xs">
        <thead>
          <tr className="border-b border-border text-muted-foreground">
            <th className="px-4 py-2 text-left font-medium">Source</th>
            <th className="px-4 py-2 text-right font-medium">Income</th>
            <th className="px-4 py-2 text-right font-medium">Expenses</th>
            <th className="px-4 py-2 text-right font-medium">Net</th>
          </tr>
        </thead>
        <tbody className="divide-y divide-border">
          {rows.map((r) => (
            <tr key={r.source} className="hover:bg-white/[0.02]" data-testid={`source-row-${r.source}`}>
              <td className="px-4 py-2.5 font-medium text-neutral-100">{r.source}</td>
              <td className="px-4 py-2.5 text-right tabular text-green-500">{fmtAUD(r.income)}</td>
              <td className="px-4 py-2.5 text-right tabular text-red-500">{fmtAUD(r.expense)}</td>
              <td className={`px-4 py-2.5 text-right tabular font-semibold ${r.net >= 0 ? "text-green-500" : "text-red-500"}`}>
                {fmtAUD(r.net)}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
